import * as React from 'react';
import Joyride, { ACTIONS, EVENTS, STATUS, CallBackProps } from "react-joyride"
import { useCookies } from '../utils/useCookies';

const all_steps = [
    { target: "#add_items", content: "This is where you add various content types including; text, images, video, PDFs and more.", showProgress: true, disableBeacon: true, },
    { target: "#locationControls", content: "These controls show the location and size of the object selected. You can manually change the location and size here.", showProgress: true, disableBeacon: true },
    { target: "#flex_third_center", content: "Here are the undo, redo and settings buttons. Click on the settings button to add or change autoplay settings and change the background color.", showProgress: true, disableBeacon: true },
    { target: "#screen_select", content: "This where your screens AKA slides are shown and where you can copy or delete an existing screen or add a new screen.", showProgress: true, disableBeacon: true },
    { target: "#preview_flow_buttons", content: "Here is where you can VIEW your flow in the player, POST a version for others to see or SAVE a draft.", disableBeacon: true }
];

interface Props {
    tutorial: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
}

export const Tour: React.FC<Props> = ({ tutorial }) => {
    const [steps,] = React.useState(all_steps);
    const [showTutorial, setShowTutorial] = tutorial
    const [stepIndex, setStepIndex] = React.useState(0);
    const [isRunning, setIsRunning] = React.useState(true);
    const [, setCookie,] = useCookies();

    React.useEffect(() => {
        if (showTutorial && stepIndex !== 0) {
            setStepIndex(0)
            setIsRunning(true)
        }
    }, [showTutorial])

    const handleJoyrideCallback = (data: CallBackProps) => {
        const { action, index, status, type } = data;

        if (([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as string[]).includes(type)) {
            // Update state to advance the tour
            setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
        }
        else if (([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)) {
            // Need to set our running state to false, so we can restart if we click start again.
            setIsRunning(false);
            setCookie("showTour", false, 365)
            setShowTutorial(false)
        }
        console.groupCollapsed(type === EVENTS.TOUR_STATUS ? `${type}:${status}` : type);
        console.info(data);
        console.groupEnd();
    };


    return (
    <Joyride 
        steps={steps} 
        showSkipButton={true} 
        run={isRunning} 
        continuous
        showProgress
        callback={handleJoyrideCallback} />
    )
}

export default Tour;
